import * as React from 'react'
import { SVGProps, memo } from 'react'

const HamburgerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={21}
    height={15}
    viewBox='0 0 21 15'
    fill='none'
    {...props}
  >
    <path
      fill='currentColor'
      d='M0 .39h20.793v4.159H0zM0 10.093h12.476v4.159H0z'
    />
  </svg>
)

const Memo = memo(HamburgerIcon)

export default Memo
